import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { TiersStoreEffects } from './effects';
import { tiersStoreReducer } from './reducer';
import { FeatureName } from './feature';

@NgModule({
	imports: [CommonModule, StoreModule.forFeature(FeatureName, tiersStoreReducer), EffectsModule.forFeature([TiersStoreEffects])]
})
export class TiersStoreModule {}
